import { IsNumber, IsString, Length } from 'class-validator';

import { CreateItemModel } from '@onArte/shared/models/website/items';

export class CreateItemManagementModel extends CreateItemModel {
  @IsString()
  @Length(32, 36)
  public ownerId: string;

  @IsNumber({}, { each: true })
  public blogPostIds?: number[];
}
